import React, { Component, Fragment } from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import './norm.css';
import './App.css';

import Header from './layout/Header';
import Modal from './layout/Modal';
import TaskCounter from './layout/TaskCounter';
import Form from './layout/Form';
import TodoList from './TodoList';
import CompletedCounter from './layout/CompletedCounter';
import About from './pages/About';

class App extends Component {
  state = {
    taskName: '',
    tasks: [],
    list: [],
    modal: false
  };

  toggleTaskPropertyAt = (property, indexToChange) => {
    const { tasks } = this.state;
    this.setState({
      tasks: tasks.map((task, index) => {
        if (index === indexToChange) {
          return {
            ...task,
            [property]: !task[property]
          };
        }
        return task;
      })
    });
  };

  toggleConfirmationAt = index =>
    this.toggleTaskPropertyAt('isCompleted', index);

  toggleEditingAt = index => this.toggleTaskPropertyAt('isEditing', index);

  setTitleAt = (title, indexToChange) =>
    this.setState({
      tasks: this.state.tasks.map((task, index) => {
        if (index === indexToChange) {
          return {
            ...task,
            title
          };
        }
        return task;
      })
    });

  removeTaskAt = index => {
    const { tasks } = this.state;
    const storage = tasks
      .filter((task, i) => {
        if (i !== index) {
          return task.title;
        } else return null;
      })
      .map(task => {
        return task.title;
      });

    this.setState({ tasks: [...tasks.filter((task, id) => id !== index)] });

    localStorage.setItem('tasks', JSON.stringify(storage));
  };

  getTotalTasks = () => this.state.tasks.length;

  addNewTaskName = e => {
    this.setState({ taskName: e.target.value });
  };

  newTaskSubmitHandler = e => {
    e.preventDefault();
    const { tasks, taskName } = this.state;
    const newTasksArrayLength = tasks.length;
    const totalAllowedTasks = 5;
    if (newTasksArrayLength < totalAllowedTasks) {
      let list = this.state.list;
      list.push(taskName);
      localStorage.setItem('tasks', JSON.stringify(list));
      this.setState({
        tasks: [
          ...tasks,
          {
            title: taskName,
            isCompleted: false,
            isEditing: false
          }
        ],
        taskName: ''
      });
    } else {
      this.openModal();
    }
  };

  getCompletedTasks = () =>
    this.state.tasks.reduce(
      (total, task) => (task.isCompleted ? total + 1 : total),
      0
    );

  openModal = () => this.setState({ modal: true });

  closeModal = () => this.setState({ modal: false });

  componentDidUpdate(prevProps, previousState) {
    const { tasks } = this.state;
    const getComplete = tasks.map(complete => complete.isCompleted);
    const checkAllTrue = getComplete.every(bool => bool === true);
    const getCompletedTasks = this.getCompletedTasks();

    if (checkAllTrue && getCompletedTasks === 5) {
      tasks.map((complete, index) => {
        if (complete.isCompleted !== previousState.tasks[index].isCompleted) {
          return this.openModal();
        }
        return null;
      });
    }
  }

  componentDidMount() {
    const { tasks } = this.state;
    let list = localStorage.getItem('tasks');
    if (list === null) {
      localStorage.setItem('tasks', JSON.stringify([]));
      list = localStorage.getItem('tasks');
    }
    const parsedList = JSON.parse(list);
    let newList = [];
    let ls = [];
    parsedList.map((li, index) => {
      ls = [...ls, li];
      newList = [
        ...newList,
        {
          title: li,
          isCompleted: false,
          isEditing: false
        }
      ];
      return newList;
    });
    this.setState({
      tasks: [...tasks, ...newList],
      list: [...ls]
    });
  }

  render() {
    const totalTasks = this.getTotalTasks();
    const numberCompleted = this.getCompletedTasks();

    return (
      <HashRouter basename='/'>
        <div className='App'>
          <div className='body'>
            <div>
              <Header />
              <main>
                <Modal
                  modal={this.state.modal}
                  openModal={this.openModal}
                  closeModal={this.closeModal}
                  message={this.state.message}
                  getTotalTasks={totalTasks}
                  getCompletedTasks={numberCompleted}
                />

                <Switch>
                  <Route
                    exact
                    path='/'
                    render={props => (
                      <Fragment>
                        <span className='title'>Task title</span>
                        <Form
                          newTaskSubmitHandler={this.newTaskSubmitHandler}
                          taskName={this.state.taskName}
                          addNewTaskName={this.addNewTaskName}
                        />

                        <TaskCounter totalTasks={totalTasks} />

                        <TodoList
                          tasks={this.state.tasks}
                          toggleConfirmationAt={this.toggleConfirmationAt}
                          toggleEditingAt={this.toggleEditingAt}
                          removeTaskAt={this.removeTaskAt}
                          setTitleAt={this.setTitleAt}
                        />

                        <CompletedCounter numberCompleted={numberCompleted} />
                      </Fragment>
                    )}
                  />
                  <Route exact path='/about' component={About} />
                </Switch>
              </main>
            </div>
          </div>
        </div>
      </HashRouter>
    );
  }
}

export default App;
